// extracted by mini-css-extract-plugin
var _1 = "ExchangeSummaryStyle-module__currency___dUbkh";
var _2 = "ExchangeSummaryStyle-module__highlighted___sfaTQ";
export { _1 as "currency", _2 as "highlighted" }
